import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * サイクル情報保存サービス
 * @export GetFolioService
 * @class GetFolioService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFolioService extends PlessJsonResponderSub<any> {
  vo = {
    OrderCode: '',
    MediumType: '',
    FeatureCode: '',
    CoopFlg142: '',
    CoopFlg163: '',
    CoopFlg185: '',
    CoopFlg240: '',
    CoopFlg210: '',
    CoopFlg302: '',
    CoopFlg515: '',
    CoopFlg451: ''
  }

  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFolioService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PageInfo: {
          condition: {
            OrderCode: this.vo.OrderCode,
            MediumType: this.vo.MediumType,
            FeatureCode: this.vo.FeatureCode,
            CoopFlg142: this.vo.CoopFlg142,
            CoopFlg163: this.vo.CoopFlg163,
            CoopFlg185: this.vo.CoopFlg185,
            CoopFlg240: this.vo.CoopFlg240,
            CoopFlg210: this.vo.CoopFlg210,
            CoopFlg302: this.vo.CoopFlg302,
            CoopFlg515: this.vo.CoopFlg515,
            CoopFlg451: this.vo.CoopFlg451
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFolioService
   */
  execute(vo: any, successFunc: Function): void {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getFolio', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFolioService
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
